import * as Yup from "yup";

import { MessagingStrategyName } from "~frontend/__generated__/graphql";

import { MessagingStrategyConfigComponent } from "./types";

const FakeMessagingStrategyConfig: MessagingStrategyConfigComponent<
  MessagingStrategyName.Fake,
  Record<string, never>
> = {
  Component: () => null,
  configValidationSchema: Yup.object(),
  formValuesToConfigInput: _ => ({ _: true }),
  campaignConfigToFormValues: _config => ({}),
  defaultFormValues: () => ({}),
};

export default FakeMessagingStrategyConfig;
